import styled from '@emotion/styled';
import css from '@styled-system/css';
import { variant } from 'styled-system';

import Flex from '../../layouts/Flex';

const DEFAULT = 'default';

const IconContainer = styled(Flex)(
  css({
    width: 'decorationLine.icon.small',
    height: 'decorationLine.icon.small',
    padding: '2px',
    borderRadius: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 0,
  }),
  ({ color }) =>
    css({
      backgroundColor:
        color === DEFAULT ? 'neutrals.7' : `decorationLine.${color}`,
    }),
  ({ iconBackground }) =>
    css({
      backgroundColor: !iconBackground && 'transparent',
    }),
  variant({
    prop: 'decorationSize',
    variants: {
      small: {
        size: 'decorationLine.icon.small',
      },
      base: {
        size: 'decorationLine.icon.base',
      },
      big: {
        size: 'decorationLine.icon.big',
      },
    },
  })
);

export default IconContainer;
